import { Component } from 'react'
import styled, { css } from 'styled-components'

const TagWrapper = styled.div`
  ${({ color = 'grey', theme }) => {
    const c = theme.colors_v2[`tag_${color}`]
    return css`
      background: ${c};
    `
  }};
  padding: 4px 8px 2px;
  color: #fcfcfd;
  border-radius: 24px;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
`

class Tag extends Component {
  render() {
    return <TagWrapper color={this.props.color}>{this.props.children}</TagWrapper>
  }
}
export default Tag
